const model = {
  title: '庫存資料',
  schema: {
    type: 'Object',
    contents: {
      skuRef: {
        name: '單品',
        type: 'ObjectId',
        reference: 'skus',
        required: true,
        refKeys: ['key'],
      },
      warehouseRef: {
        name: '倉庫',
        type: 'ObjectId',
        reference: 'warehouses',
        required: true,
        refKeys: ['key'],
      },
      qty: {
        name: '數量',
        type: 'Number',
      },
    },
  },
  index: {
    primary: {
      key: {
        skuRef: 1,
        warehouseRef: 1,
      },
      unique: true,
    },
    // WHAT THE STOCK SYNC ASKS FOR, and the only thing that makes its watermark
    // worth having: "everything in this warehouse that has moved since the last
    // pass" (see dueIn in stock/vendorSync/runSync).
    //
    // Neither half was served before. `warehouseRef` is the SECOND field of the
    // key above, so it is not a usable prefix, and `@@updatedAt` was indexed
    // nowhere -- so a query meant to pick up a handful of changed rows examined
    // every stock there is, on every pass. The point of asking what changed is
    // not to look at what did not.
    //
    // The other half of that query, `{ skuRef: { $in: [...] } }` for the rows a
    // previous pass could not reach, rides the primary key's own prefix.
    warehouseUpdated: {
      key: {
        warehouseRef: 1,
        '@@updatedAt': 1,
      },
    },
  },
  list: {
    ui: {
      fields: [
        { path: 'skuRef', width: 200 },
        { path: 'warehouseRef', width: 150 },
        { path: 'qty' },
      ],
    },
  },
  // TO REMOVE use setting in view
  export: {
    populations:
      'skus,products,warehouses,pdtSeries,pdtTypes,skuSizes,skuColors',
    populationdepth: 3,
    fields: [
      '_id',
      'skuRef.key',
      'warehouseRef.key',
      'qty',
      'skuRef.productRef.key',
      'skuRef.productRef.pdtSerieRef.key',
      'skuRef.productRef.pdtTypeRef.key',
      'skuRef.spec.skuSizeRef.key',
      'skuRef.spec.skuColorRef.key',
    ],
  },
}

const mainView = {
  title: '庫存明細',
  data: {
    bundle: {
      stockRecords: { path: ['records'], quantity: 'many' },
    },
  },
  edit: {
    ui: [
      {
        name: 'formEditor',
        fields: [['skuRef', 'warehouseRef'], ['qty']],
      },
      {
        name: 'tableEditor',
        title: 'Records',
        path: 'records',
        exclude: ['stockRef'],
        appendEmpty: false,
        // fields: ['name', 'qty'],
      },
    ],
  },
  list: {
    ui: {
      fields: [
        { path: 'skuRef', width: 300 },
        // { path: 'skuRef.productRef.name', title: '商品名稱', width: 300 },
        { path: 'warehouseRef', width: 150 },
        { path: 'qty' },
      ],
    },
    // populations: 'skus,products,warehouses',
    // populationdepth: 3,
  },
  export: {
    populations:
      'skus,products,warehouses,pdtSeries,pdtTypes,skuSizes,skuColors',
    populationdepth: 3,
    fields: [
      '_id',
      'skuRef.key',
      'warehouseRef.key',
      'qty',
      'skuRef.productRef.key',
      'skuRef.productRef.name',
      'skuRef.productRef.pdtSerieRef.key',
      'skuRef.productRef.pdtTypeRef.key',
      'skuRef.spec.skuSizeRef.key',
      'skuRef.spec.skuColorRef.key',
    ],
  },
}

export default {
  ...model,
  views: {
    main: mainView,
  },
}
